<template>
    <div>
        <!-- Modal Backdrop -->
        <div
                v-if="isdisplay"
                class="fixed inset-0 z-50 bg-gray-900 bg-opacity-50 transition-opacity duration-300"
                @click="close"
        ></div>

        <!-- Modal -->
        <div
                v-if="isdisplay"
                class="fixed inset-0 z-50 overflow-y-auto"
                tabindex="-1"
        >
            <div class="flex items-center justify-center min-h-screen p-4">
                <div class="relative bg-white rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-hidden">
                    <!-- Modal Header -->
                    <div class="flex items-center justify-between px-6 py-4 border-b bg-gray-50">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-red-100 rounded-lg">
                                <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                                </svg>
                            </div>
                            <div>
                                <h3 class="text-lg font-semibold text-gray-900">
                                    Réinitialisation du mot de passe
                                </h3>
                                <p class="text-sm text-gray-500">
                                    Confirmez la réinitialisation du mot de passe
                                </p>
                            </div>
                        </div>
                        <button
                                @click="close"
                                class="text-gray-400 hover:text-gray-500 focus:outline-none transition-colors"
                                type="button"
                        >
                            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
                            </svg>
                        </button>
                    </div>

                    <!-- Modal Body -->
                    <div class="overflow-auto max-h-[calc(90vh-180px)]">
                        <div class="p-6">
                            <!-- Warning Message -->
                            <div class="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                                <div class="flex items-start">
                                    <svg class="w-5 h-5 text-yellow-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                                    </svg>
                                    <div class="ml-3">
                                        <h4 class="text-sm font-medium text-yellow-800">Action critique</h4>
                                        <p class="text-sm text-yellow-600 mt-1">
                                            Cette action réinitialisera le mot de passe de l'utilisateur. Elle est irréversible.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Success Message -->
                            <div
                                    v-if="messagesucces"
                                    class="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg"
                            >
                                <div class="flex items-start">
                                    <svg class="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                                    </svg>
                                    <div class="ml-3">
                                        <h4 class="text-sm font-medium text-green-800">Succès</h4>
                                        <p class="text-sm text-green-700 mt-1">{{ messagesucces }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- Error Message -->
                            <div
                                    v-if="messageerror"
                                    class="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg"
                            >
                                <div class="flex items-start">
                                    <svg class="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                                    </svg>
                                    <div class="ml-3">
                                        <h4 class="text-sm font-medium text-red-800">Erreur</h4>
                                        <p class="text-sm text-red-700 mt-1">{{ messageerror }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- User Information -->
                            <div class="space-y-6" v-if="!messagesucces">
                                <!-- User Details -->
                                <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                    <div class="flex items-center mb-4">
                                        <div class="flex-shrink-0 h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center">
                      <span class="text-blue-800 font-bold text-lg">
                        {{ getUserInitials(Items.name) }}
                      </span>
                                        </div>
                                        <div class="ml-4">
                                            <h4 class="text-lg font-semibold text-gray-900">{{ Items.name }}</h4>
                                            <p class="text-sm text-gray-500">{{ Items.login }}</p>
                                        </div>
                                    </div>

                                    <div class="space-y-3">
                                        <div class="flex items-center justify-between">
                                            <span class="text-sm text-gray-600">Groupe :</span>
                                            <span class="text-sm font-medium text-gray-900">{{ Items.groupeusers || 'Non défini' }}</span>
                                        </div>
                                        <div class="flex items-center justify-between">
                                            <span class="text-sm text-gray-600">Rôle :</span>
                                            <span class="text-sm font-medium text-gray-900">{{ Items.namerole || 'Non défini' }}</span>
                                        </div>
                                        <div class="flex items-center justify-between">
                                            <span class="text-sm text-gray-600">Statut :</span>
                                            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                                                  :class="parseFloat(Items.useline) === 1 ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'">
                        {{ parseFloat(Items.useline) === 1 ? 'Administrateur' : 'Actif' }}
                      </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Confirmation Message -->
                                <div class="text-center">
                                    <div class="p-4 bg-red-50 border border-red-200 rounded-lg">
                                        <svg class="w-8 h-8 text-red-600 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.998-.833-2.732 0L4.732 16.5c-.77.833.192 2.5 1.732 2.5z"/>
                                        </svg>
                                        <h4 class="text-lg font-semibold text-red-800 mb-2">
                                            {{ titlemodal }}
                                        </h4>
                                        <p class="text-sm text-red-600">
                                            Cette action générera un nouveau mot de passe aléatoire. L'utilisateur devra le modifier à sa première connexion.
                                        </p>
                                    </div>
                                </div>

                                <!-- Password Options -->
                                <div v-if="!isProcessing" class="space-y-4 hidden">
                                    <div class="border-t pt-4">
                                        <h5 class="text-sm font-medium text-gray-700 mb-3">Options de réinitialisation</h5>

                                        <div class="space-y-3">
                                            <!-- Email Notification -->
                                            <div class="flex items-center">
                                                <input
                                                        id="send-email"
                                                        v-model="options.sendEmail"
                                                        type="checkbox"
                                                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                />
                                                <label for="send-email" class="ml-3 block text-sm text-gray-700">
                                                    <span class="font-medium">Envoyer un email de notification</span>
                                                    <p class="text-xs text-gray-500">
                                                        Un email contenant le nouveau mot de passe sera envoyé à l'utilisateur
                                                    </p>
                                                </label>
                                            </div>

                                            <!-- Force Password Change -->
                                            <div class="flex items-center">
                                                <input
                                                        id="force-change"
                                                        v-model="options.forcePasswordChange"
                                                        type="checkbox"
                                                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                        :checked="true"
                                                        disabled
                                                />
                                                <label for="force-change" class="ml-3 block text-sm text-gray-700">
                                                    <span class="font-medium">Forcer le changement à la première connexion</span>
                                                    <p class="text-xs text-gray-500">
                                                        L'utilisateur devra modifier son mot de passe immédiatement
                                                    </p>
                                                </label>
                                            </div>

                                            <!-- Generate Strong Password -->
                                            <div class="flex items-center">
                                                <input
                                                        id="strong-password"
                                                        v-model="options.generateStrongPassword"
                                                        type="checkbox"
                                                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                        :checked="true"
                                                        disabled
                                                />
                                                <label for="strong-password" class="ml-3 block text-sm text-gray-700">
                                                    <span class="font-medium">Générer un mot de passe fort</span>
                                                    <p class="text-xs text-gray-500">
                                                        Le mot de passe inclura lettres, chiffres et caractères spéciaux
                                                    </p>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Password Preview -->
                                    <div v-if="passwordPreview" class="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-lg hidden">
                                        <div class="flex items-center justify-between mb-2">
                                            <span class="text-sm font-medium text-gray-700">Nouveau mot de passe :</span>
                                            <button
                                                    @click="copyToClipboard"
                                                    class="text-xs text-blue-600 hover:text-blue-800 flex items-center"
                                            >
                                                <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                                                </svg>
                                                Copier
                                            </button>
                                        </div>
                                        <div class="flex items-center">
                                            <code class="flex-1 font-mono text-sm bg-white px-3 py-2 rounded border border-gray-300 truncate">
                                                {{ passwordPreview }}
                                            </code>
                                            <button
                                                    @click="togglePasswordVisibility"
                                                    class="ml-2 text-gray-500 hover:text-gray-700"
                                                    type="button"
                                            >
                                                <svg v-if="showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                                                </svg>
                                                <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                                                </svg>
                                            </button>
                                        </div>
                                        <div class="mt-2 flex items-center text-xs text-gray-500">
                                            <svg class="w-4 h-4 mr-1 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                                            </svg>
                                            Mot de passe généré avec succès
                                        </div>
                                    </div>
                                </div>

                                <!-- Processing State -->
                                <div v-if="isProcessing" class="text-center py-8">
                                    <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                                    <p class="text-lg font-medium text-gray-900">Réinitialisation en cours...</p>
                                    <p class="text-sm text-gray-500 mt-2">
                                        Génération du nouveau mot de passe et envoi des notifications
                                    </p>
                                </div>
                            </div>

                            <!-- Success Result -->
                            <div v-if="messagesucces && passwordPreview" class="space-y-4 hidden">
                                <div class="bg-green-50 border border-green-200 rounded-lg p-4">
                                    <div class="flex items-center mb-3">
                                        <svg class="w-6 h-6 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                        </svg>
                                        <h4 class="text-lg font-semibold text-green-800">Réinitialisation réussie</h4>
                                    </div>

                                    <div class="space-y-3">
                                        <div class="p-3 bg-white border border-green-300 rounded">
                                            <div class="flex items-center justify-between mb-2">
                                                <span class="text-sm font-medium text-gray-700">Nouveau mot de passe :</span>
                                                <button
                                                        @click="copyToClipboard"
                                                        class="text-xs text-blue-600 hover:text-blue-800 flex items-center"
                                                >
                                                    <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                                                    </svg>
                                                    Copier
                                                </button>
                                            </div>
                                            <div class="flex items-center">
                                                <code class="flex-1 font-mono text-sm bg-white px-3 py-2 rounded border border-gray-300 truncate">
                                                    {{ showPassword ? passwordPreview : '••••••••••••' }}
                                                </code>
                                                <button
                                                        @click="togglePasswordVisibility"
                                                        class="ml-2 text-gray-500 hover:text-gray-700"
                                                        type="button"
                                                >
                                                    <svg v-if="showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                                                    </svg>
                                                    <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="text-sm text-gray-600 space-y-2">
                                            <div class="flex items-center">
                                                <svg class="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                                                </svg>
                                                Mot de passe généré avec succès
                                            </div>
                                            <div v-if="options.sendEmail" class="flex items-center">
                                                <svg class="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                                                </svg>
                                                Email de notification envoyé à l'utilisateur
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="text-sm text-gray-500 p-4 bg-gray-50 rounded-lg">
                                    <div class="flex items-start">
                                        <svg class="w-4 h-4 text-gray-400 mt-0.5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                                        </svg>
                                        <div>
                                            <p class="font-medium text-gray-700">Information importante</p>
                                            <p class="mt-1">
                                                Le mot de passe doit être communiqué à l'utilisateur de manière sécurisée.
                                                Il expirera après 24 heures si non modifié.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal Footer -->
                    <div class="px-6 py-4 border-t bg-gray-50 flex justify-between items-center">
                        <button
                                v-if="!messagesucces"
                                @click="close"
                                type="button"
                                class="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
                                :disabled="isProcessing"
                        >
                            Annuler
                        </button>

                        <button
                                v-if="messagesucces"
                                @click="close"
                                type="button"
                                class="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                        >
                            Terminer
                        </button>

                        <button
                                v-if="!messagesucces && !isProcessing"
                                @click="resetPassword"
                                type="button"
                                class="px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors flex items-center space-x-2"
                        >
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                            </svg>
                            <span>Réinitialiser le mot de passe</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as JwtService from "@/common/jwt.service";
    import { randomString } from "@/allfunction";
    const axios = require('axios');

    export default {
        /* eslint-disable */
        name: "ResetPasswordModal",

        data() {
            return {
                isdisplay: false,
                titlemodal: "",
                Items: {},
                messageerror: "",
                messagesucces: "",
                isProcessing: false,
                passwordPreview: "",
                showPassword: false,
                options: {
                    sendEmail: true,
                    forcePasswordChange: true,
                    generateStrongPassword: true
                }
            };
        },

        methods: {
            close() {
                this.isdisplay = false;
                this.resetForm();
                this.$emit('closed');
            },

            show(titlemodal, Items, typedoc) {


                this.titlemodal = titlemodal;
                this.Items = { ...Items };
                this.messageerror = "";
                this.messagesucces = "";
                this.isProcessing = false;
                this.passwordPreview = "";
                this.showPassword = false;
                this.options = {
                    sendEmail: true,
                    forcePasswordChange: true,
                    generateStrongPassword: true
                };
                this.isdisplay = true;
            },

            resetForm() {
                this.Items = {};
                this.messageerror = "";
                this.messagesucces = "";
                this.passwordPreview = "";
                this.showPassword = false;
            },

            getUserInitials(username) {
                if (!username) return '??';
                return username
                    .split(' ')
                    .map(name => name[0])
                    .join('')
                    .toUpperCase()
                    .substring(0, 2);
            },

            togglePasswordVisibility() {
                this.showPassword = !this.showPassword;
            },

            generatePasswordPreview() {
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
                let password = '';
                for (let i = 0; i < 12; i++) {
                    password += chars.charAt(Math.floor(Math.random() * chars.length));
                }
                return password;
            },

            async copyToClipboard() {
                if (!this.passwordPreview) return;

                try {
                    await navigator.clipboard.writeText(this.passwordPreview);
                    this.$store.dispatch('showToast', {
                        message: "Mot de passe copié dans le presse-papier",
                        type: 'success'
                    });
                } catch (err) {
                    console.error('Failed to copy:', err);
                    this.$store.dispatch('showToast', {
                        message: "Échec de la copie dans le presse-papier",
                        type: 'error'
                    });
                }
            },

            async resetPassword_old() {
                this.isProcessing = true;
                this.messageerror = "";
                this.messagesucces = "";

                // Generate preview password
                this.passwordPreview = this.generatePasswordPreview();

                const t = this;
                let url = `${process.env.VUE_APP_API_URL}/login1478pojhgfderffg458755/${this.Items.mcle1}/resetpassword/${this.$store.state.appsociete}/${randomString(200)}`;

               /* // Add options to request
                const requestData = {
                    ...this.Items,
                    options: this.options
                };*/

                console.log("this.options *********** ",this.options)

                try {
                    /*const response = await axios.post(url, requestData, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });*/

                    let response =   axios  .get(url,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })

                    if (response.data.success) {
                        this.messagesucces = response.data.message;
                        this.messageerror = "";

                        // If the API returns a new password, use it
                       /* if (response.data.newPassword) {
                            //this.passwordPreview = response.data.newPassword;
                            this.passwordPreview = "sig";
                        }

                        this.$store.dispatch('showToast', {
                            message: response.data.message,
                            type: 'success'
                        });*/

                        toastr['success'](response.data.message,"<b></b>");

                        // Auto-close after 5 seconds
                        setTimeout(() => {
                            if (this.isdisplay) {
                                this.close();
                            }
                        }, 5000);
                    } else {
                        this.handleErrorResponse(response.data);
                    }
                } catch (error) {
                    console.error('Error resetting password:', error);
                    this.messageerror = "Une erreur est survenue. Veuillez contacter votre administrateur.";
                    /*this.$store.dispatch('showToast', {
                        message: "Une erreur est survenue. Veuillez contacter votre administrateur.",
                        type: 'error'
                    });*/
                    toastr['error']("Une erreur est survenue. Veuillez contacter votre administrateur.","<b></b>");
                } finally {
                    this.isProcessing = false;
                }
            },


            async  resetPassword(){

                this.$store.dispatch('lancerchargement',true)

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/login1478pojhgfderffg458755/'+this.Items.pidkey+'/resetpassword/'+this.$store.state.appsociete+'/'+randomString(200);
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){

                            t.messagesucces="";
                            t.messageerror="";

                            t.messagesucces=res.data.message;

                            toastr['success']( t.messagesucces,"<b></b>");


                            t.close()

                        }
                        else{

                            let errormessage="";

                            t.messageerror="";
                            t.messagesucces="";
                            if (res.data.datamessage.length>0){

                                for (let message of res.data.datamessage){

                                    if (errormessage===""){

                                        errormessage=message;

                                    }else{

                                        errormessage+=" , "+message;

                                    }


                                }


                                t.messageerror=errormessage;

                            }
                            else{
                                t.messageerror=res.data.message
                            }


                            toastr['error'](t.messageerror,"<b></b>");
                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b>Erreur</b>")
                    )
                    .finally(() => this.$store.dispatch('lancerchargement',false))







            },



            handleErrorResponse(responseData) {
                this.messageerror = "";
                this.messagesucces = "";

                if (responseData.datamessage && responseData.datamessage.length > 0) {
                    const errorMessage = responseData.datamessage.join(', ');
                    this.messageerror = errorMessage;
                   /* this.$store.dispatch('showToast', {
                        message: errorMessage,
                        type: 'error'
                    });*/

                    toastr['error'](errorMessage,"<b></b>");
                } else {
                    this.messageerror = responseData.message || "Une erreur est survenue lors de la réinitialisation.";
                    /*this.$store.dispatch('showToast', {
                        message: this.messageerror,
                        type: 'error'
                    });*/


                    toastr['error'](this.messageerror,"<b></b>");

                }
            }
        }
    };
</script>

<style scoped>
    /* Custom scrollbar */
    .max-h-\[calc\(90vh-180px\)\] {
        max-height: calc(90vh - 180px);
    }

    ::-webkit-scrollbar {
        width: 6px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    ::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }

    /* Animation for password preview */
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .bg-green-50, .bg-red-50, .bg-yellow-50 {
        animation: fadeIn 0.3s ease-out;
    }

    /* Loading spinner animation */
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .animate-spin {
        animation: spin 1s linear infinite;
    }

    /* Responsive adjustments */
    @media (max-width: 640px) {
        .max-w-md {
            max-width: 95%;
        }

        .flex-col {
            flex-direction: column;
        }

        .space-x-2 > :not([hidden]) ~ :not([hidden]) {
            margin-left: 0;
            margin-top: 0.5rem;
        }
    }
</style>